import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles

const QuillEditor = (props) => {
    const [value, setValue] = useState(props.value || '');
    const isUserTyping = useRef(false);

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'] // remove formatting
        ],
    };

    const formats = [
        'bold', 'italic', 'underline',
        'list', 'bullet'
    ];

    useEffect(() => {
        // Only update if not currently typing and value has changed
        if (!isUserTyping.current) {
            const updatedValue = convertPlainTextToHTML(props.value || '');
            if (updatedValue !== value) {
                setValue(updatedValue);
            }
        }
    }, [props.value]);

    const handleChange = (content, delta, source, editor) => {
        isUserTyping.current = true;
        setValue(content);
        
        // Call onChange for user input
        props.onChange(content);
        
        // Reset the flag after a short delay
        setTimeout(() => {
            isUserTyping.current = false;
        }, 100);
    };

    // Ensure editor grows with content
    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
          .ql-editor {
            min-height: 200px;
            max-height: none;
            overflow-y: visible;
          }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    // Convert plain text (with newlines) to basic HTML
    const convertPlainTextToHTML = (text) => {
        return text
            .split('\n')
            .map(line => `<p>${line || '<br>'}</p>`)
            .join('');
    };

    return (
        <div className="w-full max-w-4xl mx-auto p-4">
            <ReactQuill
                theme="snow"
                placeholder={props.placeholder}
                value={value}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                style={{
                    height: 'auto',
                    // marginBottom: '40px',
                }}
            />
        </div>
    );
};

export default QuillEditor; 